import * as moment_ from 'moment';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';

const moment = moment_;

export class PeselService {

  static getBirthdate(pesel: string) {
    if (isNotNullOrUndefined(pesel)) {
      let year = this._getBirthYear(pesel);
      let month = this._getBirthMonthIndex(pesel);
      let day = this._getBirthDay(pesel);
      let date = moment.utc(`${day}.${month}.${year}`, 'DD.MM.YYYY');
      return date.toDate();
    }
    return null;
  }

  static getSex(pesel: string) {
    if (parseInt(pesel[9]) % 2 === 1) {
      return 'Mężczyzna';
    } else {
      return 'Kobieta';
    }
  }

  static _getBirthYear(pesel: string) {
    let year: number;
    let month: number;
    year = 10 * parseInt(pesel[0]);
    year += parseInt(pesel[1]);
    month = 10 * parseInt(pesel[2]);
    month += parseInt(pesel[3]);
    if (month > 80 && month < 93) {
      year += 1800;
    } else if (month > 0 && month < 13) {
      year += 1900;
    } else if (month > 20 && month < 33) {
      year += 2000;
    } else if (month > 40 && month < 53) {
      year += 2100;
    } else if (month > 60 && month < 73) {
      year += 2200;
    }
    return year;
  }

  static _getBirthMonth(pesel: string) {
    let month: number;
    month = 10 * parseInt(pesel[2]);
    month += parseInt(pesel[3]);
    if (month > 80 && month < 93) {
      month -= 80;
    } else if (month > 20 && month < 33) {
      month -= 20;
    } else if (month > 40 && month < 53) {
      month -= 40;
    } else if (month > 60 && month < 73) {
      month -= 60;
    }
    return month;
  }

  static _getBirthMonthIndex(pesel: string) {
    return (this._getBirthMonth(pesel));
  }

  static _getBirthDay(pesel: string) {
    let day: number;
    day = 10 * parseInt(pesel[4]);
    day += parseInt(pesel[5]);
    return day;
  }
}
